/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// Need jQuery? Install it with "yarn add jquery", then uncomment to require it.
// var $ = require('jquery');

import 'jquery';
import 'popper.js';
import 'bootstrap';

require('./infrastructure/datadog/datadog.js');
require('./tracking/bi-session.js');
require('./utils.js');
require('./utils/ajax.js');
require('./utilities.js');
require('./follow.js');
require('./utils/infinite_scroll.js');
require('./utils/geolevel.js');
require('./tracking/bi.js');
require('./tracking/app-events.js');
require('./chat.js');
require('./grid.js');
require('./rating.js');
require('./signup.js');
require('./promos.js');
require('./utils/verticals.js');
require('./notifications.js');
require('./tracking/google.js');
require('./likes.js');
require('./events/triggers/index.js');
require('./components/index.js');
require('./styles/form-styles.js');
require('./utils/banner-info.js');
require('./utils/phishing.js');
